import React, { Component } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";
import Projects from "./pages/Projects";
export default class App extends Component {
  render() {
    //const url = process.env.PUBLIC_URL;
    //console.log(url);
    return (
      <HashRouter>
        <Routes>
          <Route path={"/"} element={<Home />} />
          <Route path={"/projects"} element={<Projects />} />
          <Route path="*" element={<h1>404</h1>} />
        </Routes>
      </HashRouter>
    );
  }
}
